/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 依頼元種別
 * @export
 * @enum {number}
 */
export enum RequestSourceTypeEnum {
    /** S.RIDEアプリ */
    SRIDE = 0,
    /** DiDi */
    DIDI = 1,
    /** Uber */
    UBER = 2,
    /** RingoPass */
    RINGO_PASS = 3,
    /** オペレーター配車 */
    SIMPLE_DISPATCH = 4
}

/**
 * 依頼元種別 の Union 型
 * @export
 * @typedef RequestSourceType
 */
export type RequestSourceType =
  typeof RequestSourceTypeEnum[keyof typeof RequestSourceTypeEnum];

/**
 * 依頼元種別 のラベルマップ
 * @export
 */
export const RequestSourceTypeLabels = {
    /**
     * 数値キー: RequestSourceTypeEnum.SRIDE
     * 名前キー:  SRIDE
     */
    [RequestSourceTypeEnum.SRIDE]: 'S.RIDEアプリ',
    SRIDE:                             'S.RIDEアプリ',
    /**
     * 数値キー: RequestSourceTypeEnum.DIDI
     * 名前キー:  DIDI
     */
    [RequestSourceTypeEnum.DIDI]: 'DiDi',
    DIDI:                             'DiDi',
    /**
     * 数値キー: RequestSourceTypeEnum.UBER
     * 名前キー:  UBER
     */
    [RequestSourceTypeEnum.UBER]: 'Uber',
    UBER:                             'Uber',
    /**
     * 数値キー: RequestSourceTypeEnum.RINGO_PASS
     * 名前キー:  RINGO_PASS
     */
    [RequestSourceTypeEnum.RINGO_PASS]: 'RingoPass',
    RINGO_PASS:                             'RingoPass',
    /**
     * 数値キー: RequestSourceTypeEnum.SIMPLE_DISPATCH
     * 名前キー:  SIMPLE_DISPATCH
     */
    [RequestSourceTypeEnum.SIMPLE_DISPATCH]: 'オペレーター配車',
    SIMPLE_DISPATCH:                             'オペレーター配車',
} as const;

/**
 * 依頼元種別 のラベル Union 型
 * @export
 * @typedef RequestSourceTypeLabel
 */
export type RequestSourceTypeLabel =
  typeof RequestSourceTypeLabels[keyof typeof RequestSourceTypeLabels];

/**
 * 依頼元種別 のラベル取得関数
 * @export
 * @param { RequestSourceType } value - 列挙体の値
 * @returns { RequestSourceTypeLabel } ラベル文字列
 */
export function getRequestSourceTypeLabel(
  value: RequestSourceType
): RequestSourceTypeLabel {
  return RequestSourceTypeLabels[value];
}

/**
 * 依頼元種別 のラベル配列を取得する関数
 * @export
 * @param { RequestSourceType[] } values - 列挙体の値配列
 * @returns { RequestSourceTypeLabel[] } ラベル文字列配列
 */
export function getRequestSourceTypeLabels(values: RequestSourceType[]): RequestSourceTypeLabel[] {
  return values.map((value) => getRequestSourceTypeLabel(value));
}

/**
 * 依頼元種別 のラベル配列
 * @export
 */
export const RequestSourceTypeLabelList = [
  'S.RIDEアプリ','DiDi','Uber','RingoPass','オペレーター配車',
] as const;

